class TpNavigation {
    /**
     * Constructor for TpNavigation.
     *
     * Caches DOM elements once and calculates the sticky offset.
     *
     * @return void
     */
    constructor() {
        // Cache DOM elements once
        this.navbarToggler = document.querySelector(".header-6 .navbar-toggler");
        this.navbarCollapse = document.querySelector(".header-6 .navbar-collapse");
        this.header = document.querySelector(".hero-section-wrapper-5 .header");

        // Early exit if critical elements are missing
        if (!this.navbarToggler || !this.navbarCollapse || !this.header) {
            console.warn("TpNavigation: Required DOM elements not found");
            return;
        }

        // Cache the sticky offset once (can be recalculated if needed)
        this.stickyOffset = this.header.offsetTop;

        this.initEventListeners();
    }

    /**
     * Initializes event listeners for the navigation component.
     *
     * Listeners are added for page-scroll links to close the mobile menu,
     * toggling the mobile menu button active state, and handling scroll events.
     */
    initEventListeners() {
        // Close mobile menu when clicking a page-scroll link
        document.querySelectorAll(".header-6 .page-scroll").forEach(link => {
            link.addEventListener("click", () => {
                this.navbarToggler.classList.remove("active");
                this.navbarCollapse.classList.remove("show");
            });
        });

        // Toggle mobile menu button active state
        this.navbarToggler.addEventListener("click", () => {
            this.navbarToggler.classList.toggle("active");
        });

        // Scroll handler – use arrow function to keep `this` context
        window.addEventListener("scroll", () => this.handleScroll(), { passive: true });

        // Run once on init (handles case when page is already scrolled on load)
        this.handleScroll();
    }

    /**
     * Handles both sticky header + active nav link highlighting
     */
    handleScroll() {
        this.updateStickyHeader();
        this.updateActiveLink();
    }

    /**
     * Makes header sticky when scrolled past its original position
     */
    updateStickyHeader() {
        if (window.scrollY > this.stickyOffset) {
            this.header.classList.add("sticky");
        } else {
            this.header.classList.remove("sticky");
        }
    }

    /**
     * Highlights the currently visible section in the navigation
     */
    updateActiveLink() {
        const links = document.querySelectorAll(".header-6 .page-scroll");
        if (!links.length) return;

        const scrollPos = window.scrollY;
        const offset = 73; // <-- adjust this value if your header height changes

        let activeSet = false;

        links.forEach(link => {
            const href = link.getAttribute("href");
            if (!href || href.startsWith("#") === false) return;

            const targetId = href.substring(1);
            const section = document.getElementById(targetId);

            if (!section) return;

            const sectionTop = section.offsetTop;
            const sectionBottom = sectionTop + section.offsetHeight;

            // Remove active from all first
            link.classList.remove("active");

            // If section is in view
            if (sectionTop <= scrollPos + offset && sectionBottom > scrollPos + offset) {
                link.classList.add("active");
                activeSet = true;
            }
        });

        // remove active state from all if nothing matches
        if (!activeSet) {
            document.querySelectorAll(".header-6 .page-scroll.active").forEach(el => {
                el.classList.remove("active");
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => new TpNavigation());
